import { useTranslation } from 'react-i18next';
import TableFooter from '@mui/material/TableFooter';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import MuiTablePagination from '@mui/material/TablePagination';

import { FORTA_GRAY4 } from '../../../../utils/colors';

import type { MouseEvent } from 'react';

const rowsPerPageOptions = [10, 20, 30, 100];

interface InvoiceListFooterProps {
  count: number;
  page: number;
  rowsPerPage: number;
  changeRowsPerPage: (page: string | number) => void;
  changePage: (newPage: number) => void;
}

const InvoiceListFooter = ({
  count,
  page,
  rowsPerPage,
  changeRowsPerPage,
  changePage,
}: InvoiceListFooterProps) => {
  const { t } = useTranslation('invoice');
  const handleRowChange = (value: string | number) => {
    changeRowsPerPage(value);
  };
  const handlePageChange = (page: number) => {
    changePage(page);
  };

  const footerStyle = {
    display: 'flex',
    justifyContent: 'center',
    padding: '10px 24px 10px 24px',
    border: 'none',
  };

  return (
    <TableFooter sx={{ border: 'none' }}>
      <TableRow sx={{ border: 'none' }}>
        <TableCell style={footerStyle}>
          <MuiTablePagination
            component="div"
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            rowsPerPageOptions={rowsPerPageOptions}
            onPageChange={(_: MouseEvent<HTMLButtonElement> | null, page: number) =>
              handlePageChange(page)
            }
            onRowsPerPageChange={(e) => handleRowChange(e.target.value)}
            labelDisplayedRows={({ from, to, count }) =>
              count !== -1
                ? t('displayedRows', { from, to, count })
                : t('displayedRowsMoreThan', { from, to })
            }
            labelRowsPerPage={t('rowsPerPage')}
            sx={{
              '.MuiTablePagination-toolbar': {
                color: FORTA_GRAY4,
                height: '36px',
              },
              '.MuiTablePagination-displayedRows': {
                marginBottom: 0,
              },
              '.MuiTablePagination-selectLabel': {
                marginBottom: 0,
              },
              '.MuiTablePagination-input': {
                padding: '2px 5px',
                borderRadius: '5px',
                border: '1px solid #ccc',
              },
              '.MuiButtonBase-root': {
                margin: '0 10px',
              },
              'MuiSvgIcon-root': {
                borderRadius: '5px',
                border: '1px solid #ccc',
              },
            }}
          />
        </TableCell>
      </TableRow>
    </TableFooter>
  );
};

export default InvoiceListFooter;
